import { render } from "./AnalisiCosti.vue?vue&type=template&id=6df1fe3c&scoped=true"
import script from "./AnalisiCosti.vue?vue&type=script&lang=js"
export * from "./AnalisiCosti.vue?vue&type=script&lang=js"

import "./AnalisiCosti.vue?vue&type=style&index=0&id=6df1fe3c&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6df1fe3c"]])

export default __exports__